/**
 * @see https://stackoverflow.com/a/55455760/
 */
export const alphaCheckerBackground = 'repeating-conic-gradient(#fff 0deg  90deg, #ccc 0 180deg) 0 0/20px 20px';